import React from "react";
import SettingSoloIcon from "../../icons/SettingSoloIcon";

const Setting = props => {
    const { handleClick } = props

    return (
        <div className="iconSetting" onClick={ handleClick }>
            <SettingSoloIcon />
        </div>
    )
}

export default Setting
